import { m } from '@aimfora/i18n'
import { createFileRoute } from '@tanstack/react-router'
import { PrintPage } from '~/components/grading/print-page'
import { getPrintViewFn } from '~/functions/grading.functions'
import { gradingKeys, scopeOf } from '~/lib/query-keys'

export const Route = createFileRoute('/_authed/app/exams/$examId_/print')({
  head: () => ({ meta: [{ title: `${m.print_title()} - ${m.app_name()}` }] }),
  loader: ({ context, params }) =>
    context.queryClient.ensureQueryData({
      queryKey: gradingKeys.print(scopeOf(context.session), params.examId),
      queryFn: () => getPrintViewFn({ data: { examId: params.examId } }),
    }),
  component: PrintRoute,
})

function PrintRoute() {
  const { examId } = Route.useParams()
  return <PrintPage examId={examId} />
}
